import { render, staticRenderFns } from "./YearWheel.vue?vue&type=template&id=c1b4c99e&scoped=true&"
import script from "./YearWheel.vue?vue&type=script&lang=ts&"
export * from "./YearWheel.vue?vue&type=script&lang=ts&"
import style0 from "./YearWheel.vue?vue&type=style&index=0&id=c1b4c99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4c99e",
  null
  
)

export default component.exports